import React, { useState } from 'react';
import { Container, Nav, Navbar, NavDropdown, Form } from 'react-bootstrap';
import MegaMenu from '../MegaMenu/MegaMenu';
import logo from '../../../Assets/Images/buypolicynow.png';
import posp from '../../../Assets/Images/MAn-02.png';
import { MDBIcon } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';
import { Tooltip } from 'antd';
import SmallNavbar from '../SmallNavbar/SmallNavbar';

const Header = ({ sticky }) => {
    const [show, setShow] = useState(false);
    const changeBackground = () => {
        if (window.scrollY >= 100 && sticky === "top") {
            setShow(true);
        } else {
            setShow(false);
        }
    }
    window.addEventListener('scroll', changeBackground);
    return (
        <>
            {
                show ? (
                    /* Content to render when show is true */
                    <SmallNavbar />
                ) : (
                    /* Content to render when show is false */
                    <>
                        <Navbar
                            collapseOnSelect
                            expand="md"
                            style={{ backgroundColor: 'white' }}
                            sticky={sticky === "true" ? "top" : undefined}
                        >
                            <Container className="header-container">
                                <div className="d-flex align-items-center justify-content-between">

                                    <Navbar.Brand className="navbar-logo" href={`${process.env.PUBLIC_URL}/`}>
                                        <img src={logo} style={{ height: "60px", width: "80px" }} className="logo-image" alt="logo" />
                                        <h5 className='h3-for-logo-text'><span>#</span>KhwaabAapkeSaathHamara</h5>
                                    </Navbar.Brand>

                                    <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                                </div>
                                <Navbar.Collapse id="responsive-navbar-nav">
                                    <Nav className=" ms-auto navbar-navs align-items-center gap-3">
                                        <NavDropdown title="About" id="basic-nav-dropdown">
                                            <NavDropdown.Item href={`${process.env.PUBLIC_URL}/about`}>About Us</NavDropdown.Item>
                                            <NavDropdown.Item href={`${process.env.PUBLIC_URL}/our-philosophy`}>
                                                Our Philosophy
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                        {/* <MegaMenu /> */}
                                        <NavDropdown title="Products" id="basic-nav-dropdown">
                                            <NavDropdown.Item href={`${process.env.PUBLIC_URL}/motor-insurance/car-insurnace`}>Car</NavDropdown.Item>
                                            <NavDropdown.Item href={`${process.env.PUBLIC_URL}`}>Bike</NavDropdown.Item>
                                            {/* <NavDropdown.Item href={`${process.env.PUBLIC_URL}/health-insurance`}>Health</NavDropdown.Item> */}
                                            <NavDropdown.Item href={`${process.env.PUBLIC_URL}`}>Health</NavDropdown.Item>
                                            {/* <NavDropdown.Item href={`${process.env.PUBLIC_URL}/life-insurance`}>Life</NavDropdown.Item> */}
                                            <NavDropdown.Item href={`${process.env.PUBLIC_URL}`}>Life</NavDropdown.Item>
                                        </NavDropdown>
                                        {/* <Nav.Link href="#support">Support</Nav.Link> */}
                                        <NavDropdown title="Contact" id="basic-nav-dropdown">
                                            <NavDropdown.Item href={`${process.env.PUBLIC_URL}/contact`}>Contact Us</NavDropdown.Item>
                                            <NavDropdown.Item href="tel:+919022264444">
                                                Need help?<br />+91 9022264444
                                            </NavDropdown.Item>
                                        </NavDropdown>
                                        {/* <NavDropdown
                                            title="More"
                                            id="collapsible-nav-dropdown"
                                            className="dropdown"
                                        >
                                            <NavDropdown.Item href="#action/3.3" className="nav-link">
                                                Something
                                            </NavDropdown.Item>
                                        </NavDropdown> */}
                                        <Nav.Link href={`${process.env.PUBLIC_URL}/posp`} className="nav-link">
                                            <div className='posp-navbar-img  d-flex align-items-center' >

                                                <button className="posp-button-blink ">
                                                    PoSP Sign up
                                                </button>

                                            </div>

                                        </Nav.Link>
                                    </Nav>

                                </Navbar.Collapse>
                            </Container>
                        </Navbar>
                    </>
                )}

        </>
    );
};

export default Header;
